import { InjectionToken } from '@angular/core';

/**
 * Injection token for the external model viewer base URL.
 * The URL varies per environment (dev, stage, prod).
 */
export const VIEWER_BASE_URL = new InjectionToken<string>('VIEWER_BASE_URL');
